<template>
  <progress
    ref="progress"
    class="t-progress"
    :class="[
      `t-progress--${type}`,
    ]"
    :value="value"
    :max="max"
  >
  </progress>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';

export default {
  name: 't-progress',
  mixins: [ColorTypeMixin],
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    isIndeterminate() {
      return this.value === undefined || this.value === null;
    },
  },
  watch: {
    isIndeterminate: {
      handler(indeterminate) {
        this.$nextTick(() => {
          if (indeterminate) {
            this.$refs.progress.removeAttribute('value');
          } else {
            this.$refs.progress.setAttribute('value', this.value);
          }
        });
      },
      immediate: true,
    },
  },
};
</script>
